import _ from "lodash";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { api, constants } from "../utils";

const OrderRangeList = [
   { label: "One Week", value: "7" },
   { label: "Two Weeks", value: "14" },
   { label: "Four Weeks", value: "28" },
   { label: "Six Weeks", value: "42" },
   { label: "Eight Weeks", value: "56" },
   { label: "Twelve Weeks", value: "84" },
   { label: "Sixteen Weeks", value: "112" },
   { label: "Twenty Weeks", value: "140" },
];

export default function useGetItemClasses(props) {
   const filterdList = _.isEmpty(props);
   const [list, setList] = useState({ list: [], Success: false, ClassList: [] });
   const payload = _.isEmpty(props) ? {} : { ...props };

   useEffect(() => {
      api
         .post("Reference/GetItemClasses", payload)
         .then((response) => {
            if (response.data?.success) {
               return response.data;
            } else {
               toast.error("Failed to find itemClasses in GetItemClasses method");
            }
         })
         .then((data) => {
            if (filterdList) {
               setList({ list: _.map(data.itemClasses, x => x.itemClassCode), success: true })
            } else {
               setList({
                  list: _.map(data.itemClasses, x => x.itemClassCode),
                  ClassList: _.map(data.itemClasses, x => {
                     return { label: x.itemClassWithDesc, value: x.itemClassCode }
                  }),
                  OrderRangeList: OrderRangeList,
                  ABCCodeList: constants.ABC_CODE_LIST,
                  Success: true
               })
            }
         })
         .catch(api.catchHandler);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);
   return list;
}
